import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { Avatar } from "@design-system/Avatar/Avatar";
import { WORKSPACE_ROLES_LABELS } from "@common/constants";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { WorkspaceMembersRow } from "../workspaceMembersRow";
import { MemberCard } from "../MemberCard";
import { OrganizationCard } from "../OrganizationCard";
import styles from "../WorkspaceMembers.module.scss";

export const UserCell = memo(function UserCell({
    row,
}: CellContext<ViewTableFeatures, WorkspaceMembersRow, unknown>) {
    const data = row.original;

    if (data.kind === "member") {
        return (
            <ViewTableCell>
                <MemberCard user={data.member.user} />
            </ViewTableCell>
        );
    }

    if (data.kind === "organization") {
        return (
            <ViewTableCell>
                <Tooltip
                    bullets={data.organizationMembers.map((member) => (
                        <span key={member.user.id}>
                            <strong className="font-weight-medium">
                                {member.user.name}
                            </strong>{" "}
                            - {WORKSPACE_ROLES_LABELS[member.role]}
                        </span>
                    ))}
                >
                    <span>
                        <OrganizationCard organization={data.organization} />
                    </span>
                </Tooltip>
            </ViewTableCell>
        );
    }

    if (data.kind === "invite") {
        return (
            <ViewTableCell>
                <span className={styles.card}>
                    <Avatar
                        name={data.invite.email ?? ""}
                        variant="outline"
                        tone="neutral"
                        size="md"
                        aria-hidden
                    />
                    {data.invite.email}
                </span>
            </ViewTableCell>
        );
    }

    return <ViewTableCell>-</ViewTableCell>;
});
